import { getStatusColor } from '../../../../utilities/StatusUtilities';

const colorBand = {
    red: 'red',
    orange: 'orange',
    yellow: 'yellow',
};

function getColorBand(color) {
    return colorBand[color] || 'blank';
}

function getColorRuns(colorList) {
    const colorRuns = [];
    let curr;
    colorList.forEach((item) => {
        const currStatus = curr?.color;
        if (currStatus === item.status) {
            curr.to = item.date;
        } else {
            if (curr) {
                curr.to = item.date;
                colorRuns.push(curr);
            }
            curr = {
                color: item.status,
                from: item.date,
                to: item.date,
            };
        }
    });
    if (curr) colorRuns.push(curr);
    return colorRuns
        .filter((item) => item.color !== 'blank')
        .map((item) => ({
            ...item,
            color: getStatusColor(item.color, 0.7),
        }));
}

export function getStatusBands(data, statusMetric) {
    if (!statusMetric) return [];
    const statusData = data?.trends?.[statusMetric];
    if (!statusData) return [];
    const timeStatusList = statusData.data.map((item) => {
        const worst = item.value?.worst;
        return {
            date: item.date,
            status: getColorBand(worst),
        };
    });
    return getColorRuns(timeStatusList);
}
